import { GameFactoryClient } from '@/app/components/game/game-factory.client';
import type { GameViewModel } from '@/types/games/game-view-model';
import { ZoneLayoutProvider } from '@/app/components/zones/contexts/zone-layout-context';
import { PRISMIC_ZONE_LAYOUT } from '@/app/constants/zone';

type CategoryPlaceholderZoneProps = {
    games: GameViewModel[];
    title?: string;
};

export const CategoryPlaceholderZone = ({ games, title }: CategoryPlaceholderZoneProps) => {
    return (
        <ZoneLayoutProvider layout={PRISMIC_ZONE_LAYOUT.ONE_ROW}>
            {title && <h2 className="zone-title-text">{title}</h2>}
            <div className={'grid-zone-layout one_row placeholder'}>
                {games.map((game, index) => (
                    <GameFactoryClient
                        key={`category-placeholder-${game.uid}-${index}`}
                        tracking={{
                            gamePosition: index
                        }}
                        game={game}
                        index={index + 1}
                        layout={PRISMIC_ZONE_LAYOUT.ONE_ROW}
                        priority={index === 0}
                    />
                ))}
            </div>
        </ZoneLayoutProvider>
    );
};
